import { geocode, RequestType } from 'react-geocode'
import { FieldErrors } from 'react-hook-form'

export const currencyRegex = /^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/

export type AddressComponentsAccProps = {
	city: string | null
	state: string | null
	county: string | null
}

export type AddressComponentsComponentProps = {
	long_name: string
	short_name: string
	types: string[]
}

export const getCityCountyStateFromZip = async (zip: string) => {
	try {
		const { results } = await geocode(RequestType.ADDRESS, zip)
		if (!results.length || !results[0].address_components) {
			return { city: null, state: null, county: null }
		}

		const { city, state, county } =
			results[0].address_components.reduce(
				(
					acc: AddressComponentsAccProps,
					component: AddressComponentsComponentProps
				) => {
					if (component.types.includes('locality')) {
						acc.city = component.long_name
					} else if (
						component.types.includes('administrative_area_level_2')
					) {
						acc.county = component.long_name.replace('County', '')
					} else if (
						component.types.includes('administrative_area_level_1')
					) {
						acc.state = component.short_name
					}
					return acc
				}
			)
		return { city, state, county }
	} catch {
		return { city: null, state: null, county: null }
	}
}

export const formStateErrorsToErrorList = (errors: FieldErrors) => {
	return Object.entries(errors).map(([key, value]) => ({
		property: key,
		message: value?.message as string,
	}))
}
